import {questionnaireService} from "api/services";
import {SaqIdentifiers, SaqUrls} from "api/saq/resourcesUrl";
import {useQuery} from "react-query";

const fetchQuestionnaire = () =>
    questionnaireService.get(SaqUrls.questionnaire);

export const useQuestionnaire = () =>
    useQuery([SaqIdentifiers.questionnaire], fetchQuestionnaire);
